import { FieldKey, FORM_CONFIG as ZOOM_FORM_CONFIG } from '../connection-zoom-form.config';
import { buildConfigList } from '../../../../../../../../infrastructure/utils/form-config.utils';
import { ConnectionType } from '../../../../../../../../api/connections.dao';

/* Zoom Meeting specific form config */
export const ZOOM_MEETING_FORM_CONFIG = {
    ...ZOOM_FORM_CONFIG,
    [FieldKey.TYPE]: {
        labelDescriptor: { id: 'oe.templates.connection.type', defaultMessage: 'Connection Type', description: 'Label text' },
        defaultValue: ConnectionType.Zoom,
        readOnly: true
    }
};

export const zoomMeetingConfigList = buildConfigList(ZOOM_MEETING_FORM_CONFIG);
